import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M9.62285 0C4.30623 0 0 4.30623 0 9.62285C0 14.9395 4.30623 19.2457 9.62285 19.2457C14.9395 19.2457 19.2457 14.9395 19.2457 9.62285C19.2457 4.30623 14.9395 0 9.62285 0ZM9.62285 16.84C5.6414 16.84 2.40571 13.6043 2.40571 9.62285C2.40571 5.6414 5.6414 2.40571 9.62285 2.40571C13.6043 2.40571 16.84 5.6414 16.84 9.62285C16.84 13.6043 13.6043 16.84 9.62285 16.84ZM23.7083 23.6482C23.2392 24.1173 22.4814 24.1173 22.0123 23.6482L17.261 18.8969L18.957 17.2009L23.7083 21.9521C24.1774 22.4092 24.1774 23.1791 23.7083 23.6482ZM10.8257 8.35987H13.2314C13.893 8.35987 14.4343 8.90115 14.4343 9.56272C14.4343 10.2243 13.893 10.7656 13.2314 10.7656H10.8257V13.1713C10.8257 13.8329 10.2844 14.3742 9.62285 14.3742C8.96128 14.3742 8.42 13.8329 8.42 13.1713V10.7656H6.01428C5.35271 10.7656 4.81143 10.2243 4.81143 9.56272C4.81143 8.90115 5.35271 8.35987 6.01428 8.35987H8.42V5.95415C8.42 5.29258 8.96128 4.7513 9.62285 4.7513C10.2844 4.7513 10.8257 5.29258 10.8257 5.95415V8.35987Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
